import Vue from 'vue'
import Vuex from 'vuex'
import OrderStore from '@/components/Orders/VuexStore/OrderStore'
import OrdersStore from '@/components/Orders/VuexStore/OrdersStore'
import AuthStore from '@/components/System/VuexStore/AuthStore'
import SystemStore from '@/components/System/VuexStore/SystemStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules:{
    order: OrderStore,
    orders: OrdersStore,
    auth: AuthStore,
    system: SystemStore
  }
})
